module.exports = __webpack_public_path__ + "static/hewanair-cbc30a2149b3f89f01073ed3cfcd04d4.png";